import * as actionTypes from "../types/types";

export const gameOver = (message) => ({
  type: actionTypes.GAME_OVER,
  payload: message,
});

export const movePlayerLeft = (player, deltaTime) => ({
  type: actionTypes.MOVE_PLAYER_LEFT,
  payload: { player: player, time: deltaTime },
});

export const movePlayerRight = (player, deltaTime) => ({
  type: actionTypes.MOVE_PLAYER_RIGHT,
  payload: { player: player, time: deltaTime },
});

export const movePlayerUp = (player, deltaTime) => ({
  type: actionTypes.MOVE_PLAYER_UP,
  payload: { player: player, time: deltaTime },
});

export const movePlayerDown = (player, deltaTime) => ({
  type: actionTypes.MOVE_PLAYER_DOWN,
  payload: { player: player, time: deltaTime },
});

export const shoot = (player) => ({
  type: actionTypes.SHOOT,
  payload: { player: player },
});

export const isStartButtonVisible = () => {
  return {
    type: actionTypes.IS_START_BUTTON_VISIBLE,
  };
};

export const toggleStartButton = (gameState) => {
  return {
    type: actionTypes.TOGGLE_START_BUTTON,
    payload: { gameState: gameState },
  };
};

export const saveGameState = (gameState) => ({
  type: actionTypes.SAVE_GAME_STATE,
  payload: gameState,
});

export const openPopupAction = () => {
  return {
    type: actionTypes.OPEN_POPUP,
  };
};

export const closePopupAction = () => {
  return {
    type: actionTypes.CLOSE_POPUP,
  };
};

export const gameWon = () => {
  return {
    type: actionTypes.GAME_WON,
  };
};

export const decreaseLives = (lives) => {
  return {
    type: actionTypes.DECREASE_LIVES,
    payload: lives,
  };
};

export const gameDone = () => {
  return {
    type: actionTypes.GAME_DONE,
  };
};

export const checkEntranceCollision = (player, entrance, currGame) => {
  return {
    type: actionTypes.CHECK_ENTRANCE_COLLISION,
    payload: { player, entrance, currGame },
  };
};

export const checkCollision = (player, enemy, currGame) => {
  return {
    type: actionTypes.CHECK_COLLISION,
    payload: { player, enemy, currGame },
  };
};

export const checkEnemyPastBottom = (enemy, height, currGame) => {
  return {
    type: actionTypes.CHECK_ENEMY_PAST_BOTTOM,
    payload: { enemy, height, currGame },
  };
};

export const updateCountdown = (num) => {
  return {
    type: actionTypes.UPDATE_COUNTDOWN,
    payload: num,
  };
};

export const replayGame = () => {
  return {
    type: actionTypes.REPLAY_GAME,
  };
};

export const pauseGame = (isPaused) => ({
  type: actionTypes.PAUSE_GAME,
  payload: isPaused,
});

export const togglePauseMessage = (message) => ({
  type: actionTypes.TOGGLE_PAUSE_MESSAGE,
  payload: message,
});

export const gameTimeout = () => ({
  type: actionTypes.GAME_TIMEOUT,
});

export const resetGame = () => ({
  type: actionTypes.RESET_GAME,
});

export const updateScore = (score) => {
  return {
    type: actionTypes.UPDATE_SCORE,
    payload: score,
  };
};
